/**
 * Gift Card Recipient Form Custom Element
 * Handles the "Send as a gift" checkbox toggle and recipient field visibility.
 */
if (!customElements.get('recipient-form')) {
  customElements.define('recipient-form', class RecipientForm extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[type="checkbox"]');
      this.recipientFields = this.querySelector('.recipient-fields');
      this.hiddenControlInput = this.querySelector('[id^="Recipient-Control"]');

      if (!this.checkbox || !this.recipientFields) return;

      // Set initial state
      this.toggleFields();

      this.checkbox.addEventListener('change', this.toggleFields.bind(this));
    }

    toggleFields() {
      if (this.checkbox.checked) {
        this.recipientFields.style.display = 'block';
        if (this.hiddenControlInput) this.hiddenControlInput.disabled = true;
        // Enable required on email
        var emailInput = this.querySelector('[name="properties[Recipient email]"]');
        if (emailInput) emailInput.required = true;
      } else {
        this.recipientFields.style.display = 'none';
        if (this.hiddenControlInput) this.hiddenControlInput.disabled = false;
        // Remove required
        var emailInput = this.querySelector('[name="properties[Recipient email]"]');
        if (emailInput) emailInput.required = false;
        // Clear fields
        this.recipientFields.querySelectorAll('input, textarea').forEach(function(field) {
          field.value = '';
        });
      }
    }

    disconnectedCallback() {
      if (this.checkbox) {
        this.checkbox.removeEventListener('change', this.toggleFields.bind(this));
      }
    }
  });
}
